import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import MESSAGE from '../../../business-const/Message/Message'

import {
    ano,
} from '../../../business-components/Date/Date'

import {
    nvl,
    formataValor,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataEstudoDiagnosticoAposentadoriaResumo,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    //DivFormEstudo,
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    calculaJaAposentou,
} from './EstudoServiceCalculo'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'



const EstudoFormEvolucaoReservaFinanceiraEstudo = ( { values, estudo, report, popup, indInicial, indFinal } ) => {

    const EvolucaoReservaFinanceiraEstudo = ( props ) => {

        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(
                    LABELESPECIAL.ano.charAt(0).toUpperCase() + LABELESPECIAL.ano.substring(1), report),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idade, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    (report ? LABEL.recursosFinanceirosAbreviado : LABEL.recursosFinanceiros) + '<br/>' + LABEL.comeco, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.aporteMedio, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    values.exibirEvolucaoAporteMensalInflacao
                        ?
                            LABEL.aporteMedioEvolucaoInflacaoQuebraEspecial
                        :
                            LABEL.aporteTotal,
                    report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.retiradaMedia, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    values.exibirEvolucaoRetiradaMensalInflacao
                        ?
                            LABEL.retiradaMediaEvolucaoInflacaoQuebraEspecial
                        :
                            LABEL.retiradaTotal,
                    report),
            },
        ]

        if (!values.exibirEvolucaoRecursosFinanceirosFinalInflacao) {
            
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.rendimentoTotal, report),
                },
            )
        }

        headList.push(
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.rendimentoMedio, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                    (report ? LABEL.recursosFinanceirosAbreviado : LABEL.recursosFinanceiros) + '<br/>' +
                        LABEL.final, report),
            },
        )

        if (values.exibirEvolucaoRecursosFinanceirosFinalInflacao) {
            
            headList.push(
                {
                    colSpan: 6,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        (report ? LABEL.recursosFinanceirosAbreviado : LABEL.recursosFinanceiros) + '<br/>' +
                            LABEL.final + ' ' + LABEL.evolucaoInflacao, report),
                },
            )
        }


        
        return (
            <div
                {...props}
            >
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                        //popup={popup}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.evolucaoReservaFinanceiraEstudo?.map((item, ind) => {

                            let colSpan = 0

                            return !indFinal || (ind >= indInicial && ind <= indFinal) ? (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.ano, report, item.boldAposentadoria)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.idadeGraficos, report, item.boldAposentadoria)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.recursosFinanceirosInicio, report,
                                            item.boldAposentadoria, true)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.aporteMedio, report, item.boldAposentadoria, true)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(
                                            values.exibirEvolucaoAporteMensalInflacao
                                                ?
                                                    item.aporteMedioEvolucaoInflacao
                                                :
                                                    item.aporteTotal,
                                            report, true, true)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.retiradaMedia, report, item.boldAposentadoria, true)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(
                                            values.exibirEvolucaoRetiradaMensalInflacao
                                                ?
                                                    item.retiradaMediaEvolucaoInflacao
                                                :
                                                    item.retiradaTotal,
                                            report, true, true)}
                                    </TableCellBodyExibeDados>

                                    {!values.exibirEvolucaoRecursosFinanceirosFinalInflacao && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                            bold={item.boldAposentadoria}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.rendimentoTotal, report, item.boldAposentadoria, true)}
                                        </TableCellBodyExibeDados>
                                    )}
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.rendimentoMedio, report, item.boldAposentadoria, true)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        bold={item.boldAposentadoria}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.recursosFinanceirosFinal, report,
                                            item.boldAposentadoria, true)}
                                    </TableCellBodyExibeDados>

                                    {values.exibirEvolucaoRecursosFinanceirosFinalInflacao && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                            bold={item.boldAposentadoria}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.recursosFinanceirosFinalEvolucaoInflacao, report,
                                                item.boldAposentadoria, true)}
                                        </TableCellBodyExibeDados>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                            :
                            (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                />
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>

                {(!indFinal || indFinal >= estudo.current.evolucaoReservaFinanceiraEstudo.length - 1) && 
                !calculaJaAposentou(values, ano(values.dataSimulacaoEstudo)) && !values.temContribuicaoFGTS && (
                        <GridItem12
                            className='mt-5 mb-5' //mt-10
                            align='center'
                        >
                            {formataEstudoDiagnosticoAposentadoriaResumo(
                                MESSAGE().resumoEvolucaoReservaFinanceira
                                    .replace('$1$', formataValor(values.reservaInicialEstudoSimulacaoFinanceira, 2))
                                    .replace('$2$', formataValor(values.totalAportesAteAposentadoriaEstudo, 2))
                                    .replace('$3$',
                                        formataValor(round(values.reservaInicioAposentadoriaEstudo -
                                            values.reservaInicialEstudoSimulacaoFinanceira -
                                                values.totalAportesAteAposentadoriaEstudo -
                                                    values.totalRetiradasAteAposentadoriaEstudo - nvl(values.aporteFGTS, 0), 2), 2))
                                    .replace('$4$', formataValor(values.reservaInicioAposentadoriaEstudo, 2))
                            )}
                        </GridItem12>
                )}
            </div>
        )
    }

    return (
        report || relatorioModoApresentacao(values)
            ?
                //<DivFormEstudo
                    //className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                //>
                    <EvolucaoReservaFinanceiraEstudo/>
                //</DivFormEstudo>
            :
                popup
                    ?
                        <DivOverflowX>
                            <EvolucaoReservaFinanceiraEstudo/>
                        </DivOverflowX>
                    :
                        <CardGridEstudoPadrao
                            label={LABEL.evolucaoReservaFinanceira}
                            component={
                                <EvolucaoReservaFinanceiraEstudo/>
                            }
                            overflowX={true}
                        />
    )
}

export default EstudoFormEvolucaoReservaFinanceiraEstudo